import { doc, getDoc, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetSingleBook = async (BookID) => {
  try {
    const BookDocument = doc(db, "Library", BookID);
    const BookSnapshot = await getDoc(
      BookDocument,
      where("IsDeleted", "==", false)
    );

    let Book = { ...BookSnapshot.data(), id: BookSnapshot.id };

    return Book;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleBook;
